import SkeletonRows from './SkeletonRows.component';

export default SkeletonRows;
